import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "login",
        component: () => import("../views/login/login.vue"),
        meta: {
            title: "实验室申报登录"
        }
    },
    {
        path: "/stop",
        name: "stop",
        component: () => import("../views/stop.vue"),
        meta: {
            title: "申报截止"
        }
    },
    // {
    //     path: "/",
    //     redirect: "/index"
    // },
    {
        path: "/login-register",
        name: "login-register",
        component: () => import("../views/login/login-register.vue"),
        meta: {
            title: "忘记密码"
        }
    },
    {
        path: "/auth-login",
        name: "auth-login",
        component: () => import("../views/login/auth-login.vue"),
        meta: {
            title: "统一身份认证登录"
        }
    },
    {
        path: "/declare",
        name: "declare",
        meta: {
            title: "申报认定管理"
        },
        component: () => import("../views/declare/index.vue"),
        children: [
            // {
            //     path: "list", //申报认定
            //     component: () => import("../views/declare/list.vue"),
            //     meta: {
            //         title: "申报认定"
            //     }
            // },
            {
                path: "add", //申报认定
                component: () => import("../views/declare/add.vue"),
                meta: {
                    title: "申报认定管理"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/declare/submit.vue"),
            //     meta: {
            //         title: "申报认定管理"
            //     }
            // }
        ]
    },
    {
        path: "/research",
        name: "research",
        meta: {
            title: "布局方案填报"
        },
        component: () => import("../views/research/index.vue"),
        children: [
            // {
            //     path: "list", //科研任务布局方案
            //     component: () => import("../views/research/list.vue"),
            //     meta: {
            //         title: "科研任务布局方案"
            //     }
            // },
            {
                path: "add", //科研任务布局方案
                component: () => import("../views/research/add.vue"),
                meta: {
                    title: "布局方案填报"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/research/submit.vue"),
            //     meta: {
            //         title: "布局方案填报"
            //     }
            // }
        ]
        //research
    },
    {
        path: "/task",
        name: "task",
        meta: {
            title: "任务签订填报"
        },
        component: () => import("../views/task/index.vue"),
        children: [
            // {
            //     path: "list", //申报认定
            //     component: () => import("../views/declare/list.vue"),
            //     meta: {
            //         title: "申报认定"
            //     }
            // },
            {
                path: "add", //申报认定
                component: () => import("../views/task/add.vue"),
                meta: {
                    title: "任务签订填报"
                }
            },
            {
                path: "submit",
                component: () => import("../views/task/components/submit.vue"),
                meta: {
                    title: "任务签订填报"
                }
            }
        ]
    },
    {
        path: "/annual",
        name: "annual",
        meta: {
            title: "年度总结填报"
        },
        component: () => import("../views/annual/index.vue"),
        children: [
            // {
            //     path: "list", //科研任务布局方案
            //     component: () => import("../views/research/list.vue"),
            //     meta: {
            //         title: "科研任务布局方案"
            //     }
            // },
            {
                path: "add", //科研任务布局方案
                component: () => import("../views/annual/add.vue"),
                meta: {
                    title: "年度总结填报"
                }
            }
            // {
            //     path: "submit",
            //     component: () => import("../views/research/submit.vue"),
            //     meta: {
            //         title: "布局方案填报"
            //     }
            // }
        ]
    },
    {
        path: "/", //根路径
        name: "home",
        meta: {
            title: "中关村高新技术企业bei认定管理"
        },
        component: () => import("../views/index.vue"), //主布局组件
        children: [
            {
                path: "index", //首页
                name: "index",
                component: () => import("../views/index/index.vue"),
                meta: {
                    title: "申报实验室首页"
                }
            },
            {
                path: "declare/list", //申报认定
                component: () => import("../views/declare/list.vue"),
                meta: {
                    title: "申报认定管理"
                }
            },
            {
                path: "research/list", //科研任务布局方案
                component: () => import("../views/research/list.vue"),
                meta: {
                    title: "布局方案填报"
                }
            },
            {
                path: "task/list", //任务签订
                component: () => import("../views/task/list.vue"),
                meta: {
                    title: "任务签订填报"
                }
            },
            {
                path: "annual/list", //年度总结
                component: () => import("../views/annual/list.vue"),
                meta: {
                    title: "年度总结填报"
                }
            },
            {
                path: "information/list",
                name: "information-index",
                component: () => import("../views/information/index.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "information/edit", //信息报送
                name: "information-edit",
                component: () => import("../views/information/information-edit.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "information/look", //信息报送
                name: "information-look",
                component: () => import("../views/information/information-look.vue"),
                meta: {
                    title: "信息报送"
                }
            },
            {
                path: "user", //用户信息
                name: "user",
                component: () => import("../views/user/index.vue"),
                meta: {
                    title: "个人信息"
                }
            },
            /* {
                path: "annual-report",
                name: "annual-report",
                component: () => import("../views/annual-report/index.vue"),
                meta: {
                    title: "实验室年报填报"
                }
            },
            {
                path: "annual-report/form",
                name: "annual-report-form",
                component: () => import("../views/annual-report/form.vue"),
                meta: {
                    title: "实验室年报填报表单"
                }
            }, */
            {
                path: "public-list",
                name: "public-list",
                component: () => import("../views/public-list/index.vue"),
                meta: {
                    title: "公示名单"
                }
            },
            {
                path: "notice-list",
                name: "notice-list",
                component: () => import("../views/notice-list/index.vue"),
                meta: {
                    title: "通知公告"
                }
            },
            {
                path: "task-sign",
                name: "task-sign",
                component: () => import("../views/task-sign/index.vue"),
                meta: {
                    title: "任务书签订"
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/zdsysSbdwClient",
    routes
});

router.beforeEach(async (to, from, next) => {
    console.log("路由守卫 - 从:", from.name, from.path, "到:", to.name, to.path);
    console.log("路由守卫 - 目标路由:", to.name, "查询参数:", to.query);

    if (to.meta.title) {
        document.title = to.meta.title;
    }

    // 如果是登录相关页面，直接放行
    if (to.name === "login" || to.name === "login-register" || to.name === "stop") {
        console.log("路由守卫 - 登录相关页面，直接放行");
        next();
        return;
    }

    // 如果是统一认证回调页面
    if (to.name === "auth-login") {
        console.log("路由守卫 - 统一认证回调页面");

        // 检查是否已经有token，如果有token说明已经认证过了，直接跳转到首页
        const token = store.getters.token;
        if (token) {
            console.log("路由守卫 - 已有token，直接跳转到首页");
            next({ path: "/index" });
            return;
        }

        // 如果有code参数，说明是从统一认证跳转回来的
        if (to.query.code) {
            console.log("路由守卫 - 有code参数，允许访问");
            // 设置会话标记，表示正在进行认证
            sessionStorage.setItem("authInProgress", "true");
            sessionStorage.setItem("authCode", to.query.code);
            next();
        } else if (sessionStorage.getItem("client-userInfo") != null && sessionStorage.getItem("client-userInfo") != "undefined" && sessionStorage.getItem("client-userInfo") != undefined) {
            console.log("路由守卫 - 有client-userInfo参数，允许访问");
            next();
        } else {
            console.log("路由守卫 - 没有code参数");

            // 检查是否有会话中的认证标记和code
            const authInProgress = sessionStorage.getItem("authInProgress");
            const authCode = sessionStorage.getItem("authCode");

            if (authInProgress === "true" && authCode) {
                console.log("路由守卫 - 检测到认证正在进行中，使用会话中的code");
                // 重定向到带有code的URL
                next({ path: "/auth-login", query: { code: authCode, state: "zdsysSbdwClient" } });
                return;
            }

            // 检查是否有会话中的认证标记和client-userInfo
            if (sessionStorage.getItem("client-userInfo")) {
                console.log("路由守卫 - 检测到认证正在进行中，使用会话中的client-userInfo");
                next({ path: "/auth-login" });
                return;
            }

            console.log("路由守卫 - 重定向到统一认证");
            // 清除可能的残留标记
            sessionStorage.removeItem("authInProgress");
            sessionStorage.removeItem("authCode");
            // 如果没有code，重定向到统一认证登录
            // window.location.replace(process.env.VUE_APP_KW_AUTH_BASE_URL + "auth/goUserLogin?systemType=zdsysSbdwClient");
            next("/");
        }
        return;
    }

    // 检查是否有token
    const token = store.getters.token;
    console.log("路由守卫 - 当前token:", token);

    if (!token) {
        console.log("路由守卫 - 没有token，重定向到统一认证");
        // 重定向到统一认证登录
        // window.location.replace(process.env.VUE_APP_KW_AUTH_BASE_URL + "auth/goUserLogin?systemType=zdsysSbdwClient");
        next("/");
        return;
    }

    console.log("路由守卫 - 有token，允许访问");
    next();
});

export default router;
